module.exports = __webpack_public_path__ + "img/ic_light_white.c4903cbd.png";